import { FeatureInfo } from "@/components/FeatureInfo";

export default function PaperTradingPublic() {
  return (
    <FeatureInfo
      eyebrow="Paper Trading"
      title="Practise with $100,000 in simulated capital"
      subtitle="Execute market and limit orders, set stops and targets, size positions and track P&L — all with virtual money. PAPER TRADING — SIMULATED MONEY. No real funds are ever involved."
      ctaLabel="Open Paper Trading"
      ctaTo="/app/paper-trading"
      note
      points={[
        { title: "Realistic mechanics", desc: "Market & limit orders, stop-loss and take-profit, position sizing and closing." },
        { title: "Full portfolio", desc: "Virtual balance, equity, open positions, daily & total P&L, win rate and profit factor." },
        { title: "Zero risk", desc: "Build discipline and test ideas without risking a single real dollar." },
        { title: "Reset anytime", desc: "Start fresh with a clean $100,000 account whenever you like." },
      ]}
    />
  );
}
